import React from "react";
import { Fade } from "react-awesome-reveal";
import "../styles/Footer.scss";
import facebook from "../images/redes/Caralibro.svg"
import appStore from "../images/App.svg"
import logo from "../images/logo.png"

const Footer = () => {

  return (
    <footer id="contacto">
        <div className="containerFooter">

            <div className="column1">
                <a href="./index.php"><img src={logo} alt="Logo Coorporativo Salcedo"/></a>
                <div className="containerTextColumn1">
                    <p>Somos una empresa mexicana especializada en servicios de limpieza industrial y comercial. Con un equipo altamente capacitado y equipos de última tecnología, ofrecemos soluciones personalizadas y de alta calidad para garantizar la satisfacción de nuestros clientes.</p>
                </div>
            </div>

            <div className="column2">
                <div>
                    <p>NOSOTROS</p>
                    <div className="textColumn2">
                        <a href="#inicio"><span>Conócenos</span></a><br/>
                        <a href="#porqueE"><span>¿Por qué elegirnos?</span></a><br/>
                    </div>
                </div><br/>
                <div>
                    <p>DATOS DE CONTACTO</p>
                    <div className="textColumn2">
                        <a href="mailto:info@sysdl.mx"><span>Envíanos un email</span></a><br/>
                        <a href="tel:+528131053905"><span>813 105 3905</span></a>
                    </div>
                </div>
            </div>
            
            <div className="column3">
                <div>
                    <p>SERVICIOS</p>
                    <div className="textColumn3">
                        <a href="#servicio1"><span>Lavado de vidrios de altura</span></a><br/>
                        <a href="#servicio3"><span>Lavado y encerado de pisos</span></a><br/><br/>
                        <span className="ubicacionTitle">CONTÁCTANOS AHORA</span><br/>
                        <a href="#formContact"><span id="ubicacion">Dejanos tus datos</span></a><br/>
                    </div>
                </div>
            </div>

            <div className="column4">
                <div>
                    <p>APPS</p>
                    <div>
                        <span>Próximamente</span>
                    </div>
                    <div className="containerImgApp">
                        <img src={appStore} alt=""/>
                    </div>
                </div>
                
                <div className="containerRedes">
                    <Fade cascade="true" direction="left"><a href="https://www.facebook.com/solucionesdlimpiezamonterrey"><img src={facebook} alt="Facebook Servicios de Limpieza Industrial y Comercial"/></a></Fade>
                </div>
            </div>

        </div>
</footer>
  );
};

export default Footer;

